<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { ref } from 'vue'

import { useAuthStore } from '@/stores/auth-store'
import { emitter } from '@/utils/mitt'

import LoadingListTable from '@/components/cargo-loading/LoadingListTable.vue'
import ManageLoadingListModal from '@/components/cargo-loading/ManageLoadingListModal.vue'
import CrumbsAndActions from '@/components/layout/CrumbsAndActions.vue'
import Breadcrumb from '@/components/layout/Breadcrumb.vue'
import MyPanel from '@/components/my-components/MyPanel.vue'
import MyButton from '@/components/my-components/MyButton.vue'

const { t } = useI18n()
const authStore = useAuthStore()

const loadingListModalOpen = ref(false)
</script>

<template>
    <CrumbsAndActions v-if="authStore.companyId">
        <Breadcrumb :to="{ name: 'cl' }" v-text="t('cargoLoading')" />
        <Breadcrumb current v-text="t('loadingList')" />
        <template #actions>
            <MyButton
                scheme="action"
                class="ml-auto"
                size="small"
                @click="emitter.emit('printLoadingLists')"
            >
                <mdi:printer class="mr-1" />
                {{ t('printEntity', { entity: t('loadingLists') }) }}
            </MyButton>
            <MyButton plain scheme="primary" size="small" @click="loadingListModalOpen = true">
                <mdi:plus-thick class="mr-1" />
                {{ t('createLoadingList') }}
            </MyButton>
        </template>
    </CrumbsAndActions>

    <RouterView />

    <MyPanel v-if="authStore.companyId" shadow>
        <LoadingListTable />
    </MyPanel>

    <ManageLoadingListModal v-model="loadingListModalOpen" @close="loadingListModalOpen = false" />
</template>
